<template>
  <div>
    <CentroList
      :centros="Object.values(site_centros(site))"
      @action_new="addCentroForm"
      @action_edit="editCentroForm"
      @action_delete="deleteCentroForm"
    />
    <modal-dialog-form
      :title="modal_title"
      :showModalDialog="showModalDialog"
      :fields_to_collect="fields_to_collect"
      :submit_button_text="submit_button_caption"
      validate
      @close-dialog="toggle_dialog"
      @submit="submit_action"
    >
    </modal-dialog-form>
  </div>
</template>

<style lang="css">
</style>

<script>
import { mapState, mapGetters } from 'vuex'
import ModalDialogForm from '@/components/explorer/ModalDialog'
import QCentro from '@/api/QCentro';
import CentroList from '@/components/centro/CentroList';

export default {
  name: 'SitesCentros',
  components: {
    ModalDialogForm,
    CentroList,
  },

  props: {
    site: {required: true},
  },

  data() {
    return {
      loading: false,
      confirm_dialog_model: false,
      tab: 'list',
      modal_title: ';-)',
      showModalDialog: false,
      submit_action: () => {},
      submit_button_caption: 'Save', // Harcoded text
      current_id: '',
      current_name: '',
      current_parent: null,
      current_url_name: null,
      current_logo: null,
      current_process_map_image: null,
      current_background_image: null,
      confirm_resolve: () => {},
      fields_to_collect: [],

      
    }
  },

  computed: {
    ...mapGetters(['sitePath', 'user']),
    ...mapState(['isLoading', 'sites', 'centros']),
  },

  methods: {
    site_centros(site) {
      const res = {};
      for (const centro of Object.values(this.centros)) {
        if (centro.site == site.id) {
          res[centro.id] = centro;
        }
      }
      return res;
    },

    get_centro_fields(item) {
      const c = item !== undefined ? item : {};
      const current_id                = c.id                || '';
      const current_name              = c.name              || '';
      const current_parent            = c.parent            || '';
      const current_url_name          = c.url_name          || '';
      const current_logo              = c.logo              || null;
      const current_background_image  = c.background_image  || null;
      const centros_as_items = ([['none', '--Sin-padre--']]).concat(
        Object.values(this.site_centros(this.site || {}))
              .map(c => [c.id, c.name])
              .sort((a, b) => a[1].localeCompare(b[1])));
     
      return [
        [
          {
            id: 'id',
            label: 'Centro Id',
            required: false,
            value: current_id,
            readonly: true,
            cols: 6,
            class: null,
            component: 'TextInput',
            placeholder: 'Automatic Id',
          },
        ], [
          {
            id: 'name',
            label: 'Centro name',
            required: true,
            value: current_name,
            readonly: false,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: "Centro's name",
          },
          {
            id: 'url_name',
            label: "Centro's URL access name",
            required: false,
            value: current_url_name,
            readonly: false,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: "Centro's URL access name",
          },
          {
            id: 'parent',
            label: "Parent Centro",
            required: true,
            value: current_parent || 'none',
            readonly: false,
            cols: 4,
            class: null,
            component: 'Select',
            placeholder: "Centro's URL access name",
            items: centros_as_items,
            multiple: false,
          },
        ], [
          {
            id: 'process_map_image',
            label: 'Processes map',
            required: false,
            value: this.current_process_map,
            readonly: false,
            cols: 4,
            class: null,
            component: 'FileInput',
            placeholder: '',
            mimetype: 'image',
          },
          {
            id: 'logo',
            label: 'Logo',
            required: false,
            value: current_logo,
            readonly: false,
            cols: 4,
            class: null,
            component: 'FileInput',
            placeholder: '',
          },
          {
            id: 'background_image',
            label: 'Background image',
            required: false,
            value: current_background_image,
            readonly: false,
            cols: 4,
            class: null,
            component: 'FileInput',
            placeholder: '',
          }
        ],
      ];
    },

    addCentroForm(item) {
      this.modal_title = `Create a new Centro`
      this.showModalDialog = true
      this.fields_to_collect = this.get_centro_fields({parent: item || {}})
      this.submit_action = this.addCentro
      this.submit_button_caption = 'Save'
    },
    
    process_form_data(fd) {
       if (fd.get('parent') == 'none') {
         fd.delete('parent');
         fd.set('parent', '');
       }
       return fd;
     },

     async addCentro(form_data) {
      form_data = this.process_form_data(form_data);
      try {
        this.loading = true;
        await QCentro.post(this.site.id, form_data);
        this.showModalDialog = false;
        this.$emit('update');
      } catch (err) {
        console.error("Centros.save_new exception ", err);
      }
      this.loading = false;
    },
    editCentroForm(item_id) {
      
      const item = (this.site_centros(this.site || {}) || {})[item_id];
      this.modal_title = `Edit Centro ${item.name}`
      this.showModalDialog = true
      this.fields_to_collect = this.get_centro_fields(item)
      this.submit_action = this.editCentro
      this.submit_button_caption = 'Save'
    },
    async editCentro(form_data) {
      form_data = this.process_form_data(form_data);
      const current_id = form_data.get('id')
      try {
        this.loading = true;
        await QCentro.put(this.site.id, current_id, form_data);
        this.showModalDialog = false;
        this.$emit('update');
      } catch (err) {
        console.error("Centros.save_edit exception ", err);
      }
      this.loading = false;
    },
    deleteCentroForm(item_id) {
      const item = (this.site_centros(this.site || {}) || {})[item_id];
      this.modal_title = `Delete ${item.name}`
      this.showModalDialog = true
      this.fields_to_collect = []
      this.submit_action = () => this.deleteCentro(item)
      this.submit_button_caption = 'Delete'
    },
    async deleteCentro(item) {
      this.showModalDialog = false;
      console.log('Delete confirmed',item)
      // TODO: If ok → send delete and update
    },

    toggle_dialog() {
      this.showModalDialog = false;
      this.modal_title = ``;
      this.fields_to_collect = [];
      this.submit_action = (()=>{});
      this.submit_button_caption = '';
    },
  },

}
</script>